import { IS_TWO_FOR_ONE_CAMPAIGN, IS_TWO_FOR_ONE_CAMPAIGN_LAST_DAY, IS_FLAGS_FETCHED } from '@/utils/store/getterTypes'
import { SignupCampaignActiveFlag, SignupCampaignLastDayActiveFlag } from '@/enums/flags'

export default {
  /**
   * Returns true if the two for one campaign is active
   *
   * @param state
   * @return {boolean}
   */
  [IS_TWO_FOR_ONE_CAMPAIGN] (state) {
    return !!state.flags[SignupCampaignActiveFlag]
  },

  /**
   * Returns true if today is the last day of the two for one campaign
   *
   * @param state
   * @return {boolean}
   */
  [IS_TWO_FOR_ONE_CAMPAIGN_LAST_DAY] (state) {
    return !!state.flags[SignupCampaignLastDayActiveFlag]
  },

  /**
   * Returns true if the flags are fetched
   *
   * @param state
   * @return {boolean}
   */
  [IS_FLAGS_FETCHED] (state) {
    return state.isFetched
  }
}
